import moment from 'moment-timezone'

export const mixin = {
    methods: {

        FORMAT_DATE: function (value, format = 'DD/MM/YYYY HH:mm') {
            return moment(value, 'YYYY-MM-DD HH:mm:ss').tz('Europe/Rome').format(format)
        },


        REMOVE_DOT: function (value) {
            if (value != undefined) {
                let v = value.toString().split('.').join('');
                v = v.toString().split('€ ').join('');
                return v;
            }
        },

        REPLACE_DOT_WITH_COMMA: function (value) {
            if (value != undefined) {
                let v = value.toString().replace(".", ",");
                return v;
            }
        },

        REPLACE_COMMA_WITH_DOT: function (value) {
            if (value != undefined) {
                let v = value.toString().replace(",", ".");
                return v;
            }
        },

        REMOVE_DOT_AND_COMMA: function (value) {
            if (value != undefined) {
                let v = value.toString().replace(/[.,]/g, '');
                return v;
            }
        },

        REMOVE_DOT_AND_REPLACE_COMMA: function (value) {
            if (value != undefined) {
                this.REMOVE_DOT(value);
                let v = value.toString().split(',').join('.');
                return v;
            }
        },

        ROUND_NUMBER: function (value) {
            return Math.round(value);
        },

        SWITCH_ACTIVITY: function () {
            if (this.page == 'mapping') {
                return 'mapping/cityList';
            }
            if (this.page == 'auction') {
                return 'auction/create';
            }
        },

        AUCTION_MAPPING_LABEL: function (value) {
            if (value === 1) {
                return 'MERCATO LIBERO';
            }
            return 'ASTE'
        },

        /*
        * For mapping color
        * */
        DEVIATION_COLOR: function (deviation) {

            if (deviation >= 0 && deviation <= 10) {
                return '<span class="abtg__dot abtg__dot-yellow">' + deviation + '%</span>';
            }
            if (deviation >= -30 && deviation < 0) {
                return '<span class="abtg__dot abtg__dot-green">' + deviation + '%</span>';

            }
            if (deviation < -30) {
                return '<span class="abtg__dot abtg__dot-blue">' + deviation + '%</span>';

            }
            return '<span class="abtg__dot abtg__dot-black">' + deviation + '%</span>';

        },

        /*
        * cut long words
        * */
        WORD_CUT: function (word, number) {
            if (word && word.length > number) {
                return word.substring(0, number) + '...';
            }
            return word;
        },
        FORMAT_PRICE(data) {
            if(data)
            {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },
        /*
        * replace redundant words
        * */
        ADDRESS_REPLACE: function (word) {
            if (word) {
                word = word.replace('via ', '');
                word = word.replace('VIA ', '');
                word = word.replace('Via ', '');
                return word;
            }

        },

        /*
        * Replace with dash empty string
        * */
        DASH_IF_EMPTY: function (string) {
            if (string == '' || string == undefined) {
                return '-';
            }
            return string;
        },

        /*
         * Which tab is to activate?
         */
        WHICH_ACTIVE_TAB: function (mq) {
            if (mq <= 50) {
                return 50;
            }

            if (mq > 50 && mq <= 70) {
                return 70;
            }

            if (mq > 70 && mq <= 90) {
                return 90;
            }
            if (mq > 90 && mq <= 110) {
                return 110;
            }
            if (mq > 110) {
                return 111;
            }
        },

        /*
            For auction

         */
        IS_IT_ERASABLE: function (value) {
            if (value == 1) {
                return '<i class="far fa-thumbs-up"></i>'
            }
            return '<i class="far fa-thumbs-down"></i>';
        },

        TRANSFORM_NULL_TO_ZERO: function (value) {
            if (value == null || value.length == 0) {
                return 0;
            }
            return value;
        },

        CHANGE_REGION_NAME: function (value) {
            switch (value) {
                case 'ABR':
                    return 'Abruzzo';
                case 'BAS':
                    return 'Basilicata';
                case 'CAL':
                    return 'Calabria';
                case 'CAM':
                    return 'Campania';
                case 'EMR':
                    return 'Emilia Romagna';
                case 'FVG':
                    return 'Friuli V. Giulia';
                case 'LAZ':
                    return 'Lazio';
                case 'LIG':
                    return 'Liguria';
                case 'LOM':
                    return 'Lombardia';
                case 'MAR':
                    return 'Marche';
                case 'MOL':
                    return 'Molise';
                case 'PIE':
                    return 'Piemonte';
                case 'PUG':
                    return 'Puglia';
                case 'SAR':
                    return 'Sardegna';
                case 'SIC':
                    return 'Sicilia';
                case 'TAA':
                    return 'Trentino A. Adige';
                case 'TOS':
                    return 'Toscana';
                case 'UMB':
                    return 'Umbria';
                case 'VDA':
                    return 'Valle d\'Aosta';
                case 'VEN':
                    return 'Veneto';


            }
        },

        AUCTION_COLOR: function (number) {
            switch (number) {
                case 1:
                    return 'small-circle red';
                case 2:
                    return 'small-circle yellow';
                case 3:
                    return 'small-circle grey';
                case 4:
                    return 'small-circle green';
                case 0:
                    return 'small-circle all';

            }
        },

        /**
         * replace comma with dot for latitude and longitude
         * @param number
         * @constructor
         */
        REPLACE_GEO_COMMA: function (value) {
            let v = value.toString().split(',').join('.');
            return v;
        },

        /**
         * for Idealista API
         * @param boolean
         * @return {string}
         * @constructor
         */
        FLOOR_IDEALISTA_LEGENDA: function (string) {
            switch (string) {
                case 'bj':
                    return 'Piano terra';
                case 'en':
                    return 'Piano rialzato';
                case 'ss':
                    return 'Semi-interrato';
                default:
                    return string + '°';
            }
        },


        /**
         * for Immobiliare API
         * @param string
         * @return {*}
         * @constructor
         */
        REMOVE_MQ: function (string) {
            let s = string.replace('m2', '').trim();
            return s.replace(' ', '');
        },

        REMOVE_EURO_AND_DOT: function (string) {
            let s = string.replace('€', '');
            return s.replace('.', '').trim();
        },

        /**
         * Trim of a string
         * @param string
         * @return {*}
         * @constructor
         */
        REMOVE_SPACE: function (string) {
            return string.trim();
        },

        FLOOR_LEGENDA(floor) {
            if (floor) {
                floor = floor.trim();
                switch (floor) {
                    case 'R':
                        return -1;
                }
            }
            return floor;
        },

        ACTIVE_URL(page) {
            let url = window.location.pathname;
            let isInside = (page.indexOf(url) > -1);
            if (isInside === true) {
                return 'block';
            }
            return 'none';
        },

        STATUS(statusId) {
            switch(statusId)
            {
                case 1:
                    return 'In Analisi';
                case 2:
                    return 'In Corso';
                case 3:
                    return 'Chiuso';
            }
        }
    }
};
